import React from 'react';
import Container from 'components/Container';
import { CardContent } from 'components/Card';
import Module from './Module';
import { ModuleProps } from './Module/Module';
import styles from './Modules.module.css';
import ModuleList from 'components/List';
import { Grid } from '../../Grid/Grid';

export interface ModulesProps {
  modules: ModuleProps[];
}

export function Modules({ modules }: ModulesProps) {
  return (
    <Grid>
      {modules.map((props, index) => (
        <Module index={index} key={props.title} {...props} />
      ))}
    </Grid>
  );
}
